import InputDropDown from 'app/components/Common/InputDropDown';
import { ItemType, pricingTypes } from 'app/modules/Constants';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { emitCabinClassClickGAEvent, emitCabinClassSelectGAEvent } from 'utils/ga-event-helpers';
import { selectPricingType } from '../../../actions/flightActions';

type InputPricingTypesProps = {
	selectPricingType: (item: ItemType) => void;
	selectedPricingType?: ItemType;
	name: string;
};

const InputPricingTypes: FC<InputPricingTypesProps> = (props) => {
	const { t } = useTranslation();

	const onSelect = (item: ItemType) => {
		emitCabinClassSelectGAEvent({
			cabin_class: item.value,
		});
		props.selectPricingType(item);
	};

	const onClick = () => {
		emitCabinClassClickGAEvent();
	};

	return (
		<InputDropDown
			onSelect={onSelect}
			onClick={onClick}
			name={props.name}
			selected={props.selectedPricingType}
			placeholder={t('keywords.pricingType')}
			items={pricingTypes}
		/>
	);
};

// @ts-ignore
const mapStateToProps = (state) => ({
	selectedPricingType: state.flight.selectedPricingType,
});

export default connect(mapStateToProps, { selectPricingType })(InputPricingTypes);
